import React from 'react'
import './Button.css'
import Button, { ButtonProps } from 'react-bootstrap/Button'
import 'bootstrap/dist/css/bootstrap.min.css'

type KycButtonProps = {
  isLoading?: boolean
  onClick?: () => void
  className?: string
} & ButtonProps

const KycButton: React.FC<KycButtonProps> = ({
  variant,
  isLoading,
  onClick,
  className,
  children,
  ...rest
}) => {
  const buttonClass = `button ${
    variant === 'outline-primary' ? 'inverse' : ''
  } ${className}`.trim()

  return (
    <Button
      variant={variant}
      className={`button ${
        variant === 'outline-primary' ? 'inverse' : null
      } ${className}`}
      onClick={onClick}
      {...rest}
      disabled={isLoading || rest.disabled}
      style={{ boxShadow: 'none', border: '1px solid' }}
    >
      {children}
    </Button>
  )
}

export default KycButton
